
























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { bd09ToGcj02 } from '@/common/util/mapUtil';

declare var markerArr: any[];

@Component({})
export default class TrajectoryView extends Vue {
    myGeo: any;
    map: any;
    currentInfoWindow : any;
    public searchValue:any = ''
    loading:boolean = false
    dialog:boolean = true
    timer:any = null
     form:any ={
       carrierOrderCode:'',
        orderCode:'',
        projectCode:'',
        carCode:'',
        originProvince:'',
        arrivalProvince:''
      }
      handleClose(done) {
        this.dialog = false;
    }

    mounted() {
        this.initMap();
        //this.searchValue = '';
        this.form ={
       carrierOrderCode:'',
        orderCode:'',
        projectCode:'',
        carCode:'',
        originProvince:'',
        arrivalProvince:''
      }   
    }
    public research(data){
       console.log('emit remap');
       this.$emit('remap',this.form,data);
       setTimeout(() => {
            this.dialog = false;
       }, 400);
    }

    center: any = undefined;

    public latitude: number = 32.164418;
    public longitude: number = 119.446448;
    //创建和初始化地图函数：
    initMap() {
        this.createMap(); //创建地图
        this.addMapControl(); //向地图添加控件
    }
    //创建地图函数：
    createMap() {
        var that = this;
        that.center = [that.longitude, that.latitude];

        //在百度地图容器中创建一个地图
        this.map = new AMap.Map('container', {
            zoom: 15,
            viewMode: '2D',
            center: that.center,
            pitch: 0,
            rotation: 0,
        });
        this.map.on('click', () => {
            if(this.currentInfoWindow) {
                this.currentInfoWindow.close();
                this.currentInfoWindow = null;
            }
        });

    }
    public marker = null;
    public polyline = null;
    public index = 0;

    deleteAll() {
        const allOverlay = this.map.getAllOverlays(); // 获取所有覆盖物[3]
        for (let i = allOverlay.length - 1; i >= 0; i--) { // 反向遍历避免删除后索引错乱[3]
            const overlay = allOverlay[i];
            if (overlay instanceof AMap.Marker) { // 判断是否为标记点
                this.map.remove(overlay);
            } else if (overlay instanceof AMap.Polyline) { // 判断是否为折线
                this.map.remove(overlay);
            }
        }
    }

    public lineArr = [];
    public car = require('../assets/img/car.png');

    setPoint(arr) {
        this.initMap();
        this.deleteAll();
        let that = this;
        if (!arr) return;

        // 初始化坐标数组
        const lngLatArr = arr.map(item =>

            new AMap.LngLat(...bd09ToGcj02(item.longitude, item.latitude))
        );

        // 批量创建标记点
        lngLatArr.forEach((lnglat, i) => {
            // 创建不同状态的图标
            const icon = new AMap.Icon({
                image: this.car,
                size: new AMap.Size(50, 50),
                imageOffset: new AMap.Pixel(0, 0)
            });

            // 创建标记
            const marker = new AMap.Marker({
                position: lnglat,
                icon: icon,
                offset: new AMap.Pixel(-16, -32) // 居中定位
            });

             var content =
                `<div style='color:#828a95;font-size:11px;font-weight:0px;max-height:250px;overflow-y:auto;'>`+
                `<div style='margin-top:5px;text-align:right;'><span style='float:left'>计划编号  </span><span style='margin-left:10px;'>` +
                arr[i].orderCodes +
                '</span></div>' +
                `<div style='margin-top:5px;text-align:right;'><span style='float:left'>运单编号  </span></span><span style='margin-left:10px;'>` +
                arr[i].carrierOrderCode +
                '</span></div>' +
                `<div style='margin-top:5px;text-align:right;'><span style='float:left'>车牌号  </span></span><span style='margin-left:10px;'>` +
                arr[i].carCode +
                '</span></div>' +
                `<div style='margin-top:5px;text-align:right;'><span style='float:left'>司机  </span></span><span style='margin-left:10px;'>` +
                arr[i].driverName +
                '</span></div>' +
                `<div style='margin-top:5px;text-align:right;'><span style='float:left'>最新位置  </span><span style='margin-left:10px;'>` +
                arr[i].address +
                '</span></div>' +
                `<div style='margin-top:5px;text-align:right;'><span style='float:left'>上报时间  </span></span><span style='margin-left:10px;'>` +
                arr[i].locationTime +
                '</span></div>'+
                `<div style='text-align:center;margin-bottom:0px;margin-top:5px;'><button id="btn" name=`+arr[i].id+` type="button" style='background-color:#06a774;color:white;border:1px solid #06a774;border-radius:5px;font-size:11px;cursor:pointer;width:50%;height:30px;'>立即定位</button></div>`+
                '</div>';

            this.map.add(marker);
            that.addClickHandler(content, marker)

            // marker.on('click', () => this.map.setZoom(14));
        });

        // 自适应视图
        if (arr.length > 0) {
            that.map.setZoomAndCenter(8,[arr[0].longitude, arr[0].latitude]);
        }
    }


    // 辅助方法：动态选择图标
    getIconByIndex(index, total) {
        if (index === 0) return 'start_icon.png';
        if (index === total - 1) return 'end_icon.png';
        return 'car_icon.png';
    }

    // 信息窗口开启方法（带事件对象）
    openInfo(content, e) {
        // this.map.clearInfoWindows(); // 关闭所有已开启的信息窗[1]
        const position = e.target.getPosition();
        this.currentInfoWindow  = new AMap.InfoWindow({
            content: content,
            offset: new AMap.Pixel(0, -30), // 调整窗口位置[5]
            autoMove: true // 自动平移地图确保窗口可见[1]
        });
        this.currentInfoWindow.open(this.map, position);
    }

    // 信息窗口开启方法（直接坐标）
    openwInfo(content, lng, lat) {
        this.map.clearInfoWindows();
        const infoWindow = new AMap.InfoWindow({
            content: content,
            anchor: 'bottom-center', // 设置锚点位置[1]
            offset: new AMap.Pixel(0, -30)
        });
        infoWindow.open(this.map, new AMap.LngLat(lng, lat));
    }

    // 点击事件处理器
    addClickHandler(content, marker) {
        let that = this;


        // 主标记点击事件
        marker.on('click', (e) => {
            this.openInfo(content, e);

            setTimeout(() => {
                document.getElementById('btn').onclick = function(val) {
                    let ddds:any = document.getElementById('btn')
                    console.log('click', document.getElementById('btn'),ddds.name);
                    that.research(ddds.name);
                }
            }, 100);
        });

        // // 自定义点击方法适配
        // marker.clickFun = (lng, lat) => {
        //     infoWindow.open(this.map, new AMap.LngLat(lng, lat));
        // };
        //
        // // 副标记处理
        // if(marker2) {
        //     marker2.on('click', () => {
        //         infoWindow.open(this.map, marker2.getPosition());
        //     });
        // }

    }


    addMapControl() {
        // 加载地图控件插件
        AMap.plugin(['AMap.ToolBar', 'AMap.Scale'], () => {
            // 添加缩放控件（左下角）
            const toolbar = new AMap.ToolBar({
                position: 'RB',  // LB=左下角，RB=右下角（默认）
                offset: [35, 45]  // 位置微调
            });
            this.map.addControl(toolbar);

            // 添加比例尺控件（左下角）
            const scale = new AMap.Scale({
                position: 'RB',  // 对应左下角
                offset: [25, 10] // 相对于缩放控件的垂直位置调整
            });
            this.map.addControl(scale);
        });
    }

}
